const listaDeRegistros = (state) => {
  return state.items
}

const loadingRegistros = (state) => {
  return state.carregando
}

const paginacao = (state) => {
  return state.paginacao
}

const configuracaoIntegracao = (state) => {
  return state.configuracaoIntegracao
}

const loadingConfiguracao = (state) => {
  return state.carregandoConfiguracao
}

const dashboardCentroFuncional = (state) => {
  return state.dashboardCentroFuncional
}

const loadingDashboard = (state) => {
  return state.carregandoDashboard
}

const paginacaoDashboard = (state) => {
  return state.paginacaoDashboard
}

export {
  listaDeRegistros,
  loadingRegistros,
  paginacao,
  configuracaoIntegracao,
  loadingConfiguracao,
  dashboardCentroFuncional,
  loadingDashboard,
  paginacaoDashboard
}